import {
  kiwiGreen, ultraMarine,
  sanguine, spaceCadet,
} from '@cogneed/react-utils';
import {
  Box,
  darken, styled,
} from '@mui/material';

const StyledToolBar = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 16,

  transition: theme.transitions.create(['left', 'marginLeft'], {
    duration: theme.transitions.duration.shortest,
  }),
  width: 'fit-content',
  marginLeft: 'auto',
  left: 'calc(50% - 130px)',
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
  alignItems: 'flex-end',
  justifyContent: 'center',
  pointerEvents: 'none',
  backgroundColor: 'transparent',
  zIndex: theme.zIndex.snackbar + 1,
  boxShadow: 'none',

  '& > .MuiButtonBase-root': {
    pointerEvents: 'auto',
    boxShadow: theme.shadows[3],
    '& .MuiCircularProgress-root': {
      color: 'inherit',
    },
    '& svg': {
      fontSize: 'inherit',
    },

    '&.standard': {
      border: `1px solid ${ultraMarine[400]}`,
      backgroundColor: 'white',
      color: ultraMarine[500],
      fontSize: 32,
      padding: 12,
      '&:hover': {
        backgroundColor: spaceCadet[100],
        color: ultraMarine[600],
      },
      '&.active': {
        border: `1px solid ${ultraMarine[500]}`,
        backgroundColor: ultraMarine[500],
        color: spaceCadet[100],
        '&:hover': {
          backgroundColor: ultraMarine[600],
          color: spaceCadet[300],
        },
      },
    },

    '&.session': {
      backgroundColor: kiwiGreen[500],
      color: kiwiGreen[100],

      transition: theme.transitions.create(['fontSize', 'padding'], {
        duration: theme.transitions.duration.shortest,
      }),

      fontSize: 42,
      padding: 13,

      '&:hover': {
        backgroundColor: darken(kiwiGreen[500], 0.1),
        color: darken(kiwiGreen[100], 0.1),
      },

      '&.active': {
        backgroundColor: sanguine[500],
        color: sanguine[100],
        fontSize: 32,
        padding: 13,
        '&:hover': {
          backgroundColor: darken(sanguine[500], 0.1),
          color: darken(sanguine[100], 0.1),
        },
      },
    },

  },
}));

export default StyledToolBar;
